export default function formatEnergySavings(
  value: number,
  defaultUnit: "kWh" | "MWh" = "kWh"
): { value: number; unit: string } {
  const units = ["Wh", "kWh", "MWh", "GWh", "TWh", "PWh"];
  let index = units.indexOf(defaultUnit);

  // Convert value up to the appropriate unit
  while (value >= 1000 && index < units.length - 1) {
    value /= 1000;
    index++;
  }

  return {
    value: Math.round(value), // Round to the nearest integer
    unit: units[index],
  };
}
